import type { ReactNode } from 'react';
import ParrotEmblem from './ParrotEmblem';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

type PageHeroProps = {
  title: string;
  subtitle: string;
  actions?: ReactNode;
  className?: string;
};

export default function PageHero({ title, subtitle, actions, className = '' }: PageHeroProps) {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <section className={`glass-panel relative rounded-3xl p-6 sm:p-8 ${className}`}>
      {/* Clip gradient to rounded corners without clipping hero action menus */}
      <div
        className="pointer-events-none absolute inset-0 overflow-hidden rounded-3xl bg-gradient-to-r from-cyan-500/10 via-indigo-400/10 to-violet-500/10"
        aria-hidden="true"
      />
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-2xl">
          <h1 className="gradient-title text-2xl font-extrabold tracking-tight sm:text-3xl">{title}</h1>
          <p className="mt-2 text-sm text-slate-600 sm:text-base">{subtitle}</p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <div className="hidden items-center gap-2 rounded-2xl border border-cyan-200/60 bg-white/70 px-3 py-2 shadow-sm backdrop-blur sm:flex">
            <ParrotEmblem className={`h-8 w-8 ${reducedMotion ? '' : 'animate-[float_4.8s_ease-in-out_infinite]'}`} animated={!reducedMotion} />
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Parrot mode</span>
          </div>
          {actions}
        </div>
      </div>
    </section>
  );
}

